var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-accounting"},[_c('expenses-navigation'),_c('expenses',{attrs:{"activityTagName":"ppc management","projectTypes":['PPC', 'INT-PPC', 'PPC-INT']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }